import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import EstudantesInactivosLayer from "../components/EstudantesInactivosLayer";
import { useTranslation } from "../i18n/I18nContext";

const EstudantesInactivosPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("inactivos.breadcrumb")} />
      <EstudantesInactivosLayer />
    </MasterLayout>
  );
};

export default EstudantesInactivosPage;
